// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/antd/dist/antd.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/circular/Circular-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/circular/Circular-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/circular/Circular-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/circular/Circular-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/circular/Circular-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/icons/nervaIconPack.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Circular';
  font-style: normal;
  font-weight: 300;
  src: local('Circular Light'), local('Circular-Light'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}
@font-face {
  font-family: 'Circular';
  font-style: normal;
  font-weight: 400;
  src: local('Circular Regular'), local('Circular-Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}
@font-face {
  font-family: 'Circular';
  font-style: italic;
  font-weight: 400;
  src: local('Circular Italic'), local('Circular-Italic'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}
@font-face {
  font-family: 'Circular';
  font-style: normal;
  font-weight: 500;
  src: local('Circular Medium'), local('Circular-Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}
@font-face {
  font-family: 'Circular';
  font-style: normal;
  font-weight: 700;
  src: local('Circular Bold'), local('Circular-Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}
@font-face {
  font-family: 'Nerva Icon Pack';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}
body {
  margin: 0;
  padding: 0;
  font-family: Circular, Helvetica, Verdana, sans-serif;
  overscroll-behavior-y: none;
}
a:hover,
a:focus {
  text-decoration: underline;
}
.ant-select-item-option {
  border-radius: 50px;
}
.PhoneInputCountryIcon--border {
  box-shadow: none !important;
  background-color: inherit !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme.less"],"names":[],"mappings":"AAUA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8GAAA;AARF;AAeA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kHAAA;AAbF;AAoBA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gHAAA;AAlBF;AAyBA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gHAAA;AAvBF;AA8BA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4GAAA;AA5BF;AAmCA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,2DAAA;AAjCF;AAoCA;EACE,SAAA;EACA,UAAA;EACA,qDAAA;EACA,2BAAA;AAlCF;AAqCA;;EAEE,0BAAA;AAnCF;AAwCA;EACE,mBAAA;AAtCF;AAyCA;EACE,2BAAA;EACA,oCAAA;AAvCF","sourcesContent":["// Antd overrides\n@primary-color: #6fcf97;\n@secondary-color: #f5f5ee;\n@p-text-size: 16px;\n\n@import '~antd/dist/antd.css';\n\n// Fonts definitions are also replicated for Stripe iframes in styles/Typography:stripeElementsOptionsFonts\n\n// Circular Light\n@font-face {\n  font-family: 'Circular';\n  font-style: normal;\n  font-weight: 300;\n  src:\n    local('Circular Light'),\n    local('Circular-Light'),\n    url('./assets/fonts/circular/Circular-Light.woff2') format('woff2');\n}\n\n// Circular Regular\n@font-face {\n  font-family: 'Circular';\n  font-style: normal;\n  font-weight: 400;\n  src:\n    local('Circular Regular'),\n    local('Circular-Regular'),\n    url('./assets/fonts/circular/Circular-Regular.woff2') format('woff2');\n}\n\n// Circular Regular Italic\n@font-face {\n  font-family: 'Circular';\n  font-style: italic;\n  font-weight: 400;\n  src:\n    local('Circular Italic'),\n    local('Circular-Italic'),\n    url('./assets/fonts/circular/Circular-Italic.woff2') format('woff2');\n}\n\n// Circular Medium\n@font-face {\n  font-family: 'Circular';\n  font-style: normal;\n  font-weight: 500;\n  src:\n    local('Circular Medium'),\n    local('Circular-Medium'),\n    url('./assets/fonts/circular/Circular-Medium.woff2') format('woff2');\n}\n\n// Circular Bold\n@font-face {\n  font-family: 'Circular';\n  font-style: normal;\n  font-weight: 700;\n  src:\n    local('Circular Bold'),\n    local('Circular-Bold'),\n    url('./assets/fonts/circular/Circular-Bold.woff2') format('woff2');\n}\n\n// Icons\n@font-face {\n  font-family: 'Nerva Icon Pack';\n  font-style: normal;\n  font-weight: 400;\n  src: url('./assets/icons/nervaIconPack.woff') format('woff');\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: Circular, Helvetica, Verdana, sans-serif; // primary also set in ./theme.ts\n  overscroll-behavior-y: none;\n}\n\na:hover,\na:focus {\n  text-decoration: underline;\n}\n\n// Custom Styles for Ant Components\n\n.ant-select-item-option {\n  border-radius: 50px;\n}\n\n.PhoneInputCountryIcon--border {\n  box-shadow: none !important;\n  background-color: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
